<template>
  <b-modal id="multi-manager-modal" ok-only @ok="ok" :title="trans('title')">
    <p>{{ trans('text') }}</p>

    <multiselect :placeholder="trans('placeholder')"
                 :selectLabel="this.$t('_select').toLowerCase()"
                 selectedLabel=""
                 :deselectLabel="this.$t('_deselect').toLowerCase()"
                 trackBy="id"
                 :options="$store.getters['security/company'].managers"
                 name="'multi-manager'"
                 label="name"
                 :multiple="true"
                 :closeOnSelect="true"
                 :clearOnSelect="false"
                 :preserveSearch="true"
                 :required="true"
                 v-model="selected"
    />

    <b-alert v-if="okClicked && !selected.length" variant="danger" show class="col-12">
      {{ trans('error') }}
    </b-alert>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
      selected: [],
      okClicked: false
    }
  },

  methods: {
    ok (event) {
      this.okClicked = true
      if (!this.selected.length) event.preventDefault()
      else this.$emit('input', this.selected.map(manager => manager.id))
    },

    trans (key) {
      return this.$t(`booking.managersValidation.${key}`)
    }
  }
}
</script>
